import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { FacultyFormValues } from "src/models/Faculty.model";
import Faculty from "../Layouts/Faculty";
import {
  useGetFacultyByIdQuery,
  useUpdateFacultyByIdMutation,
} from "src/services/FacultyService";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedFacultyId: string;
};

const EditFacultyWrapper = ({ onClose, selectedFacultyId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetFacultyByIdQuery(selectedFacultyId);
  const [updateFacultyById] = useUpdateFacultyByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: FacultyFormValues = {
    facultyName: items?.facultyName || "",
  };
  // Validation Schema
  const validationSchema = object().shape({
    facultyName: string().required("Please enter faculty name"),
  });
  // Handle Submit
  const handleSubmit = (
    values: FacultyFormValues,
    { setSubmitting, resetForm }: FormikHelpers<FacultyFormValues>
  ) => {
    updateFacultyById({ id: selectedFacultyId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Faculty
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditFacultyWrapper;
